import { LinearProgress, Paper, TableContainer } from '@material-ui/core';
import React from 'react';
import { RenderMarkDown } from '../CustomMarkDownReader';
import { AdrContentProps } from './types';

const AdrContent = ({ baseUrl, retrievedContent,isLoading, innerUrl }: AdrContentProps) => {
  return (
    <>
      <TableContainer component={Paper} style={{ padding: '2rem',overflow:'scroll',height:'100vh' }}>
        <div className="markdown-content" id="another-markdown-container">
          {isLoading && <LinearProgress/>}
          {<RenderMarkDown retrievedContents={retrievedContent} url={baseUrl} innerUrl={innerUrl} />}
        </div>
      </TableContainer>
    </>
  );
};

export default AdrContent;
